"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MortgageErrorType = void 0;
var MortgageErrorType;
(function (MortgageErrorType) {
    MortgageErrorType[MortgageErrorType["UNKNOWN"] = 0] = "UNKNOWN";
    MortgageErrorType[MortgageErrorType["NO_PLAN"] = 1] = "NO_PLAN";
    MortgageErrorType[MortgageErrorType["EXCEED_MORTGAGE_FIX_AMOUNT"] = 2] = "EXCEED_MORTGAGE_FIX_AMOUNT";
    MortgageErrorType[MortgageErrorType["EXCEED_MORTGAGE_PERCENT_AMOUNT"] = 3] = "EXCEED_MORTGAGE_PERCENT_AMOUNT";
    MortgageErrorType[MortgageErrorType["EXCEED_INCOME_HALF"] = 4] = "EXCEED_INCOME_HALF";
    MortgageErrorType[MortgageErrorType["TENOR_OVER"] = 5] = "TENOR_OVER";
})(MortgageErrorType = exports.MortgageErrorType || (exports.MortgageErrorType = {}));
